<template>
  <b-modal
    id="editStoreVoucher"
    title="Edit Voucher"
    ref="editStoreVoucher"
    size="lg-voucher"
    @hidden="closeModal"
  >
    <template v-if="modal.edit.status == true">
      <StoreVoucherForm
        :form="storeVoucher"
        fromWhatModal="edit"
        :status="modal.edit.status"
      />
    </template>
    <div slot="modal-footer">
      <b-button
        variant="ghost"
        class="btn-cancel"
        style="margin-right: 0.25rem"
        @click="closeModal"
        v-bind:disabled="loading"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        style="margin-left: 0.25rem"
        @click="sendForm"
        v-bind:disabled="loading"
      >
        <template v-if="loading">Saving...</template>
        <template v-else>Save</template>
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import StoreVoucherForm from "@/views/dstore/store-vouchers/StoreVoucherForm";
import notification from "@/services/notification";
import { mapState } from "vuex";

function initialState() {
  return {
    form: {
      name: "",
      value_type: "php",
      value: 1,
      start_date: new Date(),
      end_date: new Date(),
      visibility: false,
      voucher_codes: null,
    },
  };
}

export default {
  name: "EditStoreVoucher",
  props: ["status"],
  components: {
    StoreVoucherForm,
  },
  data() {
    return initialState();
  },
  computed: {
    ...mapState("estoreVouchers", [
      "loading",
      "errors",
      "modal",
      "storeVoucher",
    ]),
  },
  methods: {
    closeModal: function () {
      this.$store.commit("estoreVouchers/setModal", {
        type: "edit",
        status: false,
        uuid: null,
      });
    },
    async sendForm() {
      if (
        this.storeVoucher.is_free_delivery &&
        this.storeVoucher.is_delivery_discount_enable
      )
        return;

      this.$store.dispatch("estoreVouchers/resetErrors");

      if (this.storeVoucher.voucher_type == "unique") {
        var voucherCodes = this.form.voucher_codes;
        var fileInBase64 = this.storeVoucher.voucher_codes
          ? await this.getBase64(this.storeVoucher.voucher_codes)
          : null;

        this.form.voucher_codes = fileInBase64
          ? fileInBase64.split("base64,").pop()
          : null;
      } else {
        this.form.generic_code = this.storeVoucher.voucher_codes[0].code;
      }

      this.form.name = this.storeVoucher.name;
      this.form.value_type = this.storeVoucher.value_type;
      this.form.value = parseFloat(this.storeVoucher.value).toFixed(2);

      this.form.visibility = this.storeVoucher.visibility;

      this.form.voucher_type = this.storeVoucher.voucher_type;
      this.form.is_date_applicable = this.storeVoucher.is_date_applicable;

      if (this.storeVoucher.is_date_applicable) {
        this.form.start_date = this.$moment(
          this.storeVoucher.start_date
        ).format("YYYY-MM-DD");
        this.form.end_date = this.$moment(this.storeVoucher.end_date).format(
          "YYYY-MM-DD"
        );
      } else {
        this.form.start_date = null;
        this.form.end_date = null;
      }

      this.form.is_time_applicable = this.storeVoucher.is_time_applicable;
      this.form.is_unlimited = this.storeVoucher.is_unlimited;

      this.form.is_website_applicable = this.storeVoucher.is_website_applicable;
      this.form.is_customer_app_applicable = this.storeVoucher.is_customer_app_applicable;
      this.form.is_gcash_mp_applicable = this.storeVoucher.is_gcash_mp_applicable;

      this.form.minimum_spend = this.storeVoucher.minimum_spend;
      this.form.maximum_discount_value_type = this.storeVoucher.maximum_discount_value_type;
      this.form.maximum_discount_value = this.storeVoucher.maximum_discount_value;

      this.form.start_time = this.storeVoucher.start_time;
      this.form.end_time = this.storeVoucher.end_time;

      this.form.duration_redemption = this.storeVoucher.duration_redemption;
      this.form.max_user_redemption = this.storeVoucher.max_user_redemption;
      this.form.code_quantity = parseInt(this.storeVoucher.code_quantity);
      this.form.is_free_delivery = this.storeVoucher.is_free_delivery;
      this.form.is_delivery_discount_enable = this.storeVoucher.is_delivery_discount_enable;
      this.form.delivery_discount_value = this.storeVoucher.delivery_discount_value;
    
      if (this.storeVoucher.is_unlimited) {
        this.form.code_quantity = 0;
      }

      let param = {
        uuid: this.storeVoucher.uuid,
        param: this.form,
      };

      if (this.storeVoucher.voucher_codes != null) {
        if (this.storeVoucher.voucher_codes.size > 2097152) {
          notification.warning(
            "This file can't be uploaded, because it (" +
              this.formatBytes(this.storeVoucher.voucher_codes.size) +
              ") exceeds the maximum  upload size (2MB) for this site."
          );
        } else {
          let _this = this;
          await this.$store
            .dispatch("estoreVouchers/updateStoreVoucher", param)
            .then(function () {
              if (_this.errors == null) {
                _this.clearFields();
                _this.closeModal();
                let param = {
                  page: 1,
                  payload: null,
                };
                _this.$store.dispatch("estoreVouchers/getStoreVouchers", param);
              } else {
                if (_this.storeVoucher.voucher_type == "unique") {
                  _this.storeVoucher.voucher_codes = voucherCodes;
                }
              }
            });
        }
      } else {
        let _this = this;
        await this.$store
          .dispatch("estoreVouchers/updateStoreVoucher", param)
          .then(function () {
            if (_this.errors == null) {
              _this.clearFields();
              _this.closeModal();
              let param = {
                page: 1,
                payload: null,
              };
              _this.$store.dispatch("estoreVouchers/getStoreVouchers", param);
            } else {
              if (_this.storeVoucher.is_unlimited) {
                _this.storeVoucher.code_quantity = "";
              }
            }
          });
      }
    },
    async getBase64(file, onLoadCallback) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          resolve(reader.result);
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    formatBytes(bytes) {
      if (bytes < 1024) return bytes + " Bytes";
      else if (bytes < 1048576) return (bytes / 1024).toFixed(3) + " KB";
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(3) + " MB";
      else return (bytes / 1073741824).toFixed(3) + " GB";
    },
    clearFields() {
      this.$store.dispatch("estoreVouchers/resetErrors");
      Object.assign(this.$data, initialState());
    },
  },
  watch: {
    status: function (status) {
      if (status == true) {
        this.$refs.editStoreVoucher.show();
      } else {
        this.$refs.editStoreVoucher.hide();
      }
    },
  },
};
</script>

<style>
</style>
